import { useMemo } from "react";
import { func, string, bool } from "prop-types";
import { Button } from "@components";
import { makeStyles } from "@material-ui/styles"
import { rgb2hsl } from "@utils/colorParsers";
import classnames from "classnames";

export const ColorSquare = ({
  hex,
  selected,
  onSelect
}) => {
  const isWhiteish = useMemo(() => (
    hex ? rgb2hsl(hex)?.l >= 0.95 : true
  ), [hex]);
  
  const classes = useStyle(isWhiteish);
  
  const handleSelect = () => {
    onSelect(hex);
  }
  
  return <Button
    color="secondary"
    className={classnames(classes.block, selected && classes.selected)}
    style={{ backgroundColor: hex }}
    onClick={handleSelect}
  />
}

ColorSquare.propTypes = {
  hex: string.isRequired,
  onSelect: func.isRequired,
  selected: bool,
}

const useStyle = makeStyles((theme) => ({
  block: {
    height: 24,
    width: 24,
    minWidth: 24,
    margin: 4,
    padding: 0,
    borderRadius: 5,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: (isWhiteish) => isWhiteish ? theme.props.border : "transparent",
  },
  selected: {
    borderWidth: 2,
    borderColor: theme.palette.primary.main + " !important",
  }
}));